import { isMobile, getCookie, isSsr, localStorage } from '@lemonade-hq/cdk';
export { getDataEventParams } from '@lemonade-hq/cdk';
import { getRegion } from '@lemonade-hq/lemonation';
import { getTld } from '@lemonade-hq/ts-helpers';
import isbot from 'isbot';
import UAParser from 'ua-parser-js';
import { SESSION_COOKIE, Cookie, getJSONCookie, setJSONCookie } from '../config/cookies.esm.js';
import { getLocaleFromHtml } from './html.esm.js';
import { getEnv } from './infra.esm.js';

/* eslint-disable @typescript-eslint/naming-convention */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var ANALYTICS_SERVICE_URL = {
    development: undefined,
    production: "https://analytics.lemonade.com",
    sandbox: undefined,
    staging: "https://analytics-master.lmndstaging.com",
    test: undefined
};
var UTMs = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "utm_unique_id"
];
function getAnalyticsDataObject(param, anonymously) {
    var eventName = param.eventName, props = param.props, cookieProps = param.cookieProps;
    var _window_analytics, _window_analytics_user, _window_analytics_user_call, _window_analytics_user_call_id;
    var agent = new UAParser();
    var brand = getRawBrandName();
    var _agent_getOS = agent.getOS(), name = _agent_getOS.name, version = _agent_getOS.version;
    var _window_analytics_user_id, _agent_getBrowser_name, _agent_getBrowser_version;
    var data = _object_spread_props(_object_spread(_object_spread_props(_object_spread({
        type: eventName
    }, anonymously ? undefined : {
        user_id: (_window_analytics_user_id = (_window_analytics = window.analytics) === null || _window_analytics === void 0 ? void 0 : (_window_analytics_user = _window_analytics.user) === null || _window_analytics_user === void 0 ? void 0 : (_window_analytics_user_call = _window_analytics_user.call(_window_analytics)) === null || _window_analytics_user_call === void 0 ? void 0 : (_window_analytics_user_call_id = _window_analytics_user_call.id) === null || _window_analytics_user_call_id === void 0 ? void 0 : _window_analytics_user_call_id.call(_window_analytics_user_call)) !== null && _window_analytics_user_id !== void 0 ? _window_analytics_user_id : ""
    }), {
        referrer: document.referrer,
        url_path: window.location.href,
        client: getClientForTracking(),
        timestamp: new Date().toISOString(),
        "user-agent": window.navigator.userAgent,
        session_id: getCookie(SESSION_COOKIE)
    }), cookieProps ? {
        cookieProps: cookieProps
    } : {}), {
        properties: _object_spread_props(_object_spread({}, props), {
            parsed_user_agent: {
                browser: (_agent_getBrowser_name = agent.getBrowser().name) !== null && _agent_getBrowser_name !== void 0 ? _agent_getBrowser_name : "",
                browser_version: (_agent_getBrowser_version = agent.getBrowser().version) !== null && _agent_getBrowser_version !== void 0 ? _agent_getBrowser_version : "",
                bot: isbot(window.navigator.userAgent),
                bot_name: "",
                os_platform: brand,
                platform_logic: "web",
                device_brand: getBrandName(brand, agent),
                device_model: getModel(brand, agent),
                device_type: isMobile() ? "mobile" : "desktop",
                mobile_app: "false",
                mobile_web: isMobile(),
                os: "".concat(name, " ").concat(version),
                platform_version: version
            }
        })
    });
    return data;
}
function getLocaleForTracking() {
    var _getLocaleFromHtml;
    return (_getLocaleFromHtml = getLocaleFromHtml()) !== null && _getLocaleFromHtml !== void 0 ? _getLocaleFromHtml : localStorage.get("l_locale");
}
function getClientForTracking() {
    return isMobile() ? "mobile_web" : "web";
}
function getUUID() {
    var _getCookie;
    return (_getCookie = getCookie(Cookie.UUID)) !== null && _getCookie !== void 0 ? _getCookie : "";
}
function getUserId() {
    var _getCookie;
    return (_getCookie = getCookie(Cookie.UserId)) !== null && _getCookie !== void 0 ? _getCookie : "";
}
function getSegmentIoOptions() {
    var _window_analytics, _window_analytics_user, _window_analytics_user_call, _window_analytics_user_call_id;
    return _object_spread({}, ((_window_analytics = window.analytics) === null || _window_analytics === void 0 ? void 0 : (_window_analytics_user = _window_analytics.user) === null || _window_analytics_user === void 0 ? void 0 : (_window_analytics_user_call = _window_analytics_user.call(_window_analytics)) === null || _window_analytics_user_call === void 0 ? void 0 : (_window_analytics_user_call_id = _window_analytics_user_call.id) === null || _window_analytics_user_call_id === void 0 ? void 0 : _window_analytics_user_call_id.call(_window_analytics_user_call)) == null ? {
        integrations: {
            "Customer.io": false
        }
    } : {});
}
//  user agent internal helpers
function getRawBrandName() {
    var _window_navigator_userAgent_split_;
    var _window_navigator_userAgent_split__split_;
    return (_window_navigator_userAgent_split__split_ = (_window_navigator_userAgent_split_ = window.navigator.userAgent.split("(")[1]) === null || _window_navigator_userAgent_split_ === void 0 ? void 0 : _window_navigator_userAgent_split_.split(";")[0]) !== null && _window_navigator_userAgent_split__split_ !== void 0 ? _window_navigator_userAgent_split__split_ : "";
}
function getBrandName(brand, agent) {
    if (brand === "Macintosh" || brand === "iPhone") return "apple";
    if (brand.includes("Windows")) return "pc";
    var _agent_getDevice_vendor;
    return (_agent_getDevice_vendor = agent.getDevice().vendor) !== null && _agent_getDevice_vendor !== void 0 ? _agent_getDevice_vendor : "";
}
function getModel(brand, agent) {
    if (brand === "Macintosh" || brand === "iPhone") return "mac";
    if (brand.includes("Windows")) return "pc";
    var _agent_getDevice_model;
    return (_agent_getDevice_model = agent.getDevice().model) !== null && _agent_getDevice_model !== void 0 ? _agent_getDevice_model : "";
}
function getDefaultAnalyticsProps() {
    var searchParams = new URLSearchParams(window.location.search);
    var locale = getLocaleForTracking();
    var utmValues = getJSONCookie(Cookie.UTMs);
    var _searchParams_get, _ref, _searchParams_get1, _ref1, _searchParams_get2, _ref2, _searchParams_get3, _ref3, _searchParams_get4, _ref4;
    return {
        event_type: "client_event",
        l_client: getClientForTracking(),
        l_source: (_ref = (_searchParams_get = searchParams.get("utm_source")) !== null && _searchParams_get !== void 0 ? _searchParams_get : utmValues.utm_source) !== null && _ref !== void 0 ? _ref : "",
        l_medium: (_ref1 = (_searchParams_get1 = searchParams.get("utm_medium")) !== null && _searchParams_get1 !== void 0 ? _searchParams_get1 : utmValues.utm_medium) !== null && _ref1 !== void 0 ? _ref1 : "",
        l_campaign: (_ref2 = (_searchParams_get2 = searchParams.get("utm_campaign")) !== null && _searchParams_get2 !== void 0 ? _searchParams_get2 : utmValues.utm_campaign) !== null && _ref2 !== void 0 ? _ref2 : "",
        l_content: (_ref3 = (_searchParams_get3 = searchParams.get("utm_content")) !== null && _searchParams_get3 !== void 0 ? _searchParams_get3 : utmValues.utm_content) !== null && _ref3 !== void 0 ? _ref3 : "",
        l_term: (_ref4 = (_searchParams_get4 = searchParams.get("utm_term")) !== null && _searchParams_get4 !== void 0 ? _searchParams_get4 : utmValues.utm_term) !== null && _ref4 !== void 0 ? _ref4 : "",
        l_locale: locale !== null && locale !== void 0 ? locale : "",
        l_client_uuid: getUUID(),
        country: locale != null ? getRegion(locale) : "",
        region: locale != null ? getRegion(locale) : ""
    };
}
function isTrackingViaCookiesEnabled() {
    return getCookie(Cookie.EnableCookie) === "true";
}
var isTrackingCookieExistInDocument = function() {
    if (isSsr()) return false;
    return getCookie(Cookie.EnableCookie) != null;
};
var isBannerAcceptedCookieExistInDocument = function() {
    if (isSsr()) return false;
    return getCookie(Cookie.CookieBannerAccepted) != null;
};
function prepareTracking(query) {
    var currentUtmValues = getJSONCookie(Cookie.UTMs);
    var utmValues = UTMs.reduce(function(acc, utm) {
        var utmValue = query[utm];
        if (utmValue != null && utmValue.length > 0) {
            return _object_spread_props(_object_spread({}, acc), _define_property({}, utm, utmValue));
        }
        return acc;
    }, currentUtmValues);
    setJSONCookie(Cookie.UTMs, utmValues, {
        domain: getTld(window.location.hostname)
    });
    var locale = query.locale;
    if (locale != null && locale.length > 0) {
        localStorage.set("l_locale", query.locale);
    }
}
function trackDataForGtm(name, props) {
    if (typeof window === "undefined") {
        return;
    }
    var _window_dataLayer;
    //  eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    window.dataLayer = (_window_dataLayer = window.dataLayer) !== null && _window_dataLayer !== void 0 ? _window_dataLayer : [];
    var trackingData = _object_spread({
        event: name
    }, props);
    window.dataLayer.push(trackingData);
}
var alias = function(id, prevId) {
    if (prevId == null) {
        var _window_analytics, _window_analytics_alias;
        (_window_analytics = window.analytics) === null || _window_analytics === void 0 ? void 0 : (_window_analytics_alias = _window_analytics.alias) === null || _window_analytics_alias === void 0 ? void 0 : _window_analytics_alias.call(_window_analytics, id);
    } else {
        var _window_analytics1, _window_analytics_alias1;
        (_window_analytics1 = window.analytics) === null || _window_analytics1 === void 0 ? void 0 : (_window_analytics_alias1 = _window_analytics1.alias) === null || _window_analytics_alias1 === void 0 ? void 0 : _window_analytics_alias1.call(_window_analytics1, id, prevId);
    }
};
function identify(id, traits) {
    if (typeof id === "string") {
        if (traits == null) {
            var _window_analytics, _window_analytics_identify;
            (_window_analytics = window.analytics) === null || _window_analytics === void 0 ? void 0 : (_window_analytics_identify = _window_analytics.identify) === null || _window_analytics_identify === void 0 ? void 0 : _window_analytics_identify.call(_window_analytics, id);
        } else {
            var _window_analytics1, _window_analytics_identify1;
            (_window_analytics1 = window.analytics) === null || _window_analytics1 === void 0 ? void 0 : (_window_analytics_identify1 = _window_analytics1.identify) === null || _window_analytics_identify1 === void 0 ? void 0 : _window_analytics_identify1.call(_window_analytics1, id, traits);
        }
    } else {
        var _window_analytics2, _window_analytics_identify2;
        var newTraits = id;
        (_window_analytics2 = window.analytics) === null || _window_analytics2 === void 0 ? void 0 : (_window_analytics_identify2 = _window_analytics2.identify) === null || _window_analytics_identify2 === void 0 ? void 0 : _window_analytics_identify2.call(_window_analytics2, newTraits);
    }
}
var reset = function() {
    var _window_analytics, _window_analytics_reset;
    (_window_analytics = window.analytics) === null || _window_analytics === void 0 ? void 0 : (_window_analytics_reset = _window_analytics.reset) === null || _window_analytics_reset === void 0 ? void 0 : _window_analytics_reset.call(_window_analytics);
};
var isCurrentTrackedUser = function(userId) {
    var _window_analytics, _window_analytics_user, _window_analytics_user_call, _window_analytics_user_call_id;
    return ((_window_analytics = window.analytics) === null || _window_analytics === void 0 ? void 0 : (_window_analytics_user = _window_analytics.user) === null || _window_analytics_user === void 0 ? void 0 : (_window_analytics_user_call = _window_analytics_user.call(_window_analytics)) === null || _window_analytics_user_call === void 0 ? void 0 : (_window_analytics_user_call_id = _window_analytics_user_call.id) === null || _window_analytics_user_call_id === void 0 ? void 0 : _window_analytics_user_call_id.call(_window_analytics_user_call)) === userId;
};
function initTracking() {
    var uuid = getUUID();
    if (uuid !== "") {
        var traits = {
            l_uuid: uuid
        };
        identify(traits);
    }
}
var register = function(userConfig) {
    var userId = userConfig.userId, email = userConfig.email, givenName = userConfig.givenName, familyName = userConfig.familyName;
    alias(userId);
    var props = _object_spread({
        created_at: Math.round(Date.now() / 1000),
        id: userId,
        first_name: givenName,
        last_name: familyName,
        email: email
    }, getDefaultAnalyticsProps());
    identify(userId, props);
};
var trackWithAnalyticsService = function(param, anonymously) {
    var eventName = param.eventName, props = param.props, reportingUrl = param.reportingUrl, cookieProps = param.cookieProps;
    if (reportingUrl == null) return;
    // ATM we don't want to track at all when anonymously
    if (anonymously === true) {
        return;
    }
    var data = getAnalyticsDataObject({
        eventName: eventName,
        props: props,
        cookieProps: cookieProps
    }, anonymously);
    fetch("".concat(reportingUrl, "/events"), {
        // we use fetch and not client.ts axios post because the analytics-service do not have the right CORS setup
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json"
        }
    }).catch(function() {});
};
function trackPage() {
    var _window_analytics, _window_analytics_ready;
    (_window_analytics = window.analytics) === null || _window_analytics === void 0 ? void 0 : (_window_analytics_ready = _window_analytics.ready) === null || _window_analytics_ready === void 0 ? void 0 : _window_analytics_ready.call(_window_analytics, function() {
        var _window_analytics, _window_analytics_page;
        (_window_analytics = window.analytics) === null || _window_analytics === void 0 ? void 0 : (_window_analytics_page = _window_analytics.page) === null || _window_analytics_page === void 0 ? void 0 : _window_analytics_page.call(_window_analytics, {}, getSegmentIoOptions());
    });
    trackWithAnalyticsService({
        eventName: "page.view",
        props: _object_spread({}, getDefaultAnalyticsProps()),
        reportingUrl: ANALYTICS_SERVICE_URL[getEnv()]
    });
}
function trackEvent(eventName) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, anonymously = arguments.length > 2 ? arguments[2] : void 0;
    var eventProps = _object_spread({}, getDefaultAnalyticsProps(), props);
    if (eventProps.statsd != null && eventProps.statsd.length > 0) {
        eventProps.statsd = "".concat(getEnv(), ".business.web.").concat(props.statsd);
    }
    trackEventWithSegment(eventName, eventProps);
    trackWithAnalyticsService({
        eventName: eventName,
        props: eventProps,
        reportingUrl: ANALYTICS_SERVICE_URL[getEnv()]
    }, anonymously);
}
function trackEventWithSegment(eventName) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _window_analytics;
    if (((_window_analytics = window.analytics) === null || _window_analytics === void 0 ? void 0 : _window_analytics.user) == null) {
        var _window_analytics1, _window_analytics_ready;
        (_window_analytics1 = window.analytics) === null || _window_analytics1 === void 0 ? void 0 : (_window_analytics_ready = _window_analytics1.ready) === null || _window_analytics_ready === void 0 ? void 0 : _window_analytics_ready.call(_window_analytics1, function() {
            var _window_analytics, _window_analytics_track;
            (_window_analytics = window.analytics) === null || _window_analytics === void 0 ? void 0 : (_window_analytics_track = _window_analytics.track) === null || _window_analytics_track === void 0 ? void 0 : _window_analytics_track.call(_window_analytics, eventName, props, getSegmentIoOptions());
        });
    } else {
        var _window_analytics2, _window_analytics_track;
        (_window_analytics_track = (_window_analytics2 = window.analytics).track) === null || _window_analytics_track === void 0 ? void 0 : _window_analytics_track.call(_window_analytics2, eventName, props, getSegmentIoOptions());
    }
}

export { ANALYTICS_SERVICE_URL, alias, getAnalyticsDataObject, getBrandName, getClientForTracking, getDefaultAnalyticsProps, getModel, getRawBrandName, getSegmentIoOptions, getUUID, getUserId, identify, initTracking, isBannerAcceptedCookieExistInDocument, isCurrentTrackedUser, isTrackingCookieExistInDocument, isTrackingViaCookiesEnabled, prepareTracking, register, reset, trackDataForGtm, trackEvent, trackPage, trackWithAnalyticsService };
